import React, { useState, useEffect } from 'react';

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

import { useParams, useNavigate } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';

import axios from '../../api/axios';

import '../../styles/styles.css'; // Sesuaikan path jika berbeda
import BottomNav from '../../components/BottomNav';
import HeaderWithBack from '../../components/HeaderWithBack';
import SendEmail from '../../components/modal/SendEmail';
import { FaCalendarAlt } from 'react-icons/fa';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

type TrackingData = {
  order_id: string;
  status: string;
  updated_time: string;
};


const EprescriptionDetail: React.FC = () => {
  const navigate = useNavigate();
  const { prescriptionId } = useParams<{ prescriptionId: string }>();
  const storedData = sessionStorage.getItem('userData');
  const userData = storedData ? JSON.parse(storedData) : null;
  const token = userData ? userData.token : null;
  const email = userData ? userData.userData : null;

  const [prescriptionData, setPrescriptionData] = useState<any>(null);
  const [prescriptionOrder, setPrescriptionOrder] = useState<any>(false);
  const [prescriptionOrderData, setPrescriptionOrderData] = useState<any>(null);
  const [prescriptionOrderTracking, setPrescriptionOrderTracking] = useState<TrackingData[]>([]);
  
  const [showPdf, setShowPdf] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`prescriptions/${prescriptionId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });

        const data = response.data.data;
        console.log(data, "data");
        setPrescriptionData(data);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const fetchCheckOrder = async () => {
      const response = await axios.get(`prescriptions/check-order/${prescriptionId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
          }
      })

      const data = response.data.data;

      if (data.order === null){
        setPrescriptionOrder(false)
      } else {
        setPrescriptionOrder(true)
        setPrescriptionOrderData(data)

      }
    }

    const fetchCheckTrackingOrder = async () => {
      setIsLoading(true); // mulai loading
      try {
        const response = await axios.get(`prescriptions/tracking-order/${prescriptionId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = response.data.data;
        if (Array.isArray(data)) {
          setPrescriptionOrderTracking(data);
        } else {
          setPrescriptionOrderTracking([]);
        }
      } catch (error) {
        console.error('Tracking order error:', error);
        setPrescriptionOrderTracking([]);
      } finally {
        setIsLoading(false); // selesai loading
      }
    };
    
    fetchData(); // Selalu fetch saat Home dirender
    fetchCheckOrder();
    fetchCheckTrackingOrder();
  }, [token, prescriptionId]);

  useEffect(() => {
    
    setShowPdf(prescriptionData?.download === 1 ? true : false)
  }, [prescriptionData])

 
  const [numPages, setNumPages] = useState<number | null>(null);

  const publicPdfUrl = prescriptionData?.pdf_url;
  const publicPdfUrlDownload = prescriptionData?.pdf_url_download;
  const handleDownloadPdf = () => {
    console.log('Public PDF URL:', publicPdfUrl); // Tambahkan ini
    if (publicPdfUrlDownload) {
      // setShowPdf(!showPdf);
      setShowButton(false);
      const link = document.createElement('a');
      link.href = publicPdfUrlDownload;
      link.download = 'resep_telekonsultasi.pdf'; // Saran: tambahkan ini untuk nama file default
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.warn('URL PDF tidak tersedia untuk diunduh.');
    }
  };

  let isExpired = false;

  if (prescriptionData?.expired) {
    const [day, month, year] = prescriptionData.expired.split("-");
    const expiredDate = new Date(`${year}-${month}-${day}`);
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    expiredDate.setHours(0, 0, 0, 0);

    isExpired = expiredDate < today;
  }

  const handleSendEmail = () => { 
    setShowModal(true)
  }

  const handleConfirm = () => {
    try {
      axios.get(`prescriptions/send-email/${prescriptionId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
       alert('Berhasil mengirim resep')
      setShowButton(false);
    } catch (error) {
      alert('Gagal mengirim resep')
    } finally {
      setIsLoading(false); // selesai loading
      setShowModal(false)
    }
  }

  return (
    <div className="min-h-screen bg-white flex flex-col pb-20">
      {/* Header */}
      <HeaderWithBack title="E-Prescription" />

      {/* Info Resep */}
      <div className="bg-teal-500 text-white px-4 py-2 flex items-center">
        <FaCalendarAlt className="mr-2" />
        <span>Resep Online Anda</span>
      </div>
      
      {prescriptionData?.expired && (!prescriptionOrder || prescriptionData?.download !== 1) && (
        isExpired ? (
          <div className="bg-red-500 text-white px-4 py-2 text-sm text-center">
            Resep Sudah Kadaluarsa <br /> <strong>{prescriptionData.expired}</strong>
          </div>
        ) : (
          <div className="bg-yellow-100 text-yellow-800 px-4 py-2 text-sm text-center">
            Lakukan penebusan obat sebelum <br /> <strong>{prescriptionData.expired}</strong>
          </div>
        )
      )}

      {/* Resep Digital */}
      <div className="px-4 mt-4">
        <div className="bg-white border rounded-md shadow-sm p-4">
          <h2 className="font-semibold text-gray-800 mb-2">Resep Digital</h2>
          <div className="flex items-center border rounded-md p-3 mb-3">
            <img
              src={prescriptionData?.avatar_doctor}
              alt="doctor"
              className="w-10 h-10 rounded-full mr-3"
            />
            <div>
              <p className="font-semibold text-sm">{prescriptionData?.doctor}</p>
              <p className="text-xs text-gray-500">{prescriptionData?.specialty}</p>
            </div>
          </div>

          <div className="flex justify-between items-center text-sm mb-2">
            <p className="font-semibold">R/ {prescriptionData?.code}</p>
            <p className="text-gray-500">Tanggal Konsultasi: <br /> {prescriptionData?.date}</p>
          </div>

          {prescriptionData?.items?.map((item: any, index: number) => (
            <div
              key={index}
              className="border px-3 py-2 rounded-md text-sm bg-gray-50 mb-2"
            >
              {item?.drug_name} x {item?.qty} {item?.unit} ({item?.frequency_dd} x {item?.frequency})
            </div>
          ))}

          {/* Catatan Alergi */}
          <div className="mt-4">
            <h3 className="font-semibold text-sm mb-2">Catatan Alergi :</h3>
            { prescriptionData?.allergies.length ? prescriptionData?.allergies?.map((alergi: any, index: number) => (
              <div key={index} className="border rounded-md p-2 mb-2 text-sm">
                <p className="font-semibold">{alergi?.allergy}</p>
                <p className="text-gray-500">Catatan : {alergi?.allergy_note || '-'}</p>
              </div>
            )) : (
              <p className="text-gray-500">Tidak ada catatan alergi</p>
            ) }
          </div>
        </div>
      </div>
      {prescriptionOrder ? (
      <>
      
    {/* Detail Pengiriman */}
    <div className="px-4 mt-4">
      <div className="border shadow rounded bg-white">
        <div className="flex p-4">
          {/* Ikon sesuai tampilan original */}
          <img
            src="https://m.linksehat.com/assets/img/icons/delivery-order-icon.png"
            alt="Delivery Icon"
            className="h-[30px]"
          />
          <div className="px-4 self-center text-gray-700 w-full">
            Detail Pengirim
          </div>
          <div className="px-4 self-center text-gray-700 ml-auto">
            Apotek K24
          </div>
        </div>

        <div className="px-4 pb-4">
          <div>
            <span className="font-bold">{prescriptionOrderData.order?.outlet}</span>
          </div>
          <div>
            <span>{prescriptionOrderData.order?.shipping_method}</span>
          </div>
        </div>
      </div>
    </div>

    <div className="px-4 mt-4">
      <div className="bg-white border rounded-md shadow-sm p-4">
        {/* Header dengan Icon dan Judul */}
        <div className="flex items-center mb-3">
          <div className="bg-teal-100 text-teal-600 p-2 rounded-full mr-2">
            <i className="fas fa-box-open"></i>
          </div>
          <h2 className="font-semibold text-gray-800 text-sm">Detail Paket</h2>
        </div>

        {/* Detail Pesanan */}
        <div className="text-sm mb-4">
          <p className="font-semibold mb-1">Detail Pesanan :</p>
          <div className="pl-2">
            {prescriptionData?.items?.map((item: any, index: number) => (
              <p>{item?.drug_name}</p>
            ))}
          </div>
        </div>

        {/* Biaya dan Total */}
        <div className="text-sm mb-4">
          <div className="flex justify-between">
            <span>Biaya Pengiriman</span>
            <span>Rp {prescriptionOrderData.order?.shipping_cost.toLocaleString('id-ID')}</span>
          </div>
          <div className="flex justify-between font-bold">
            <span>Total Pesanan</span>
            <span>Rp {prescriptionOrderData.order?.shipping_cost.toLocaleString('id-ID')}</span>
          </div>
        </div>

        {/* Metode Pembayaran */}
        <div className="text-sm mb-2">
          <p className="font-semibold mb-1">Metode Pembayaran :</p>
          <div className="pl-2">
            <p><span>Biller Code: </span>{prescriptionOrderData.transaction?.merchant_code}</p>
            <p><span>Bill Key: </span>{prescriptionOrderData.transaction?.va}</p>
              {prescriptionOrderData.transaction?.status_payment !== 'payment' ? (
                <p><span>Bayar Sebelum : </span>{prescriptionOrderData.transaction?.expired_date}</p>
              ) : null 
              }
          </div>
        </div>

        {/* Total Bayar & Status */}
        <div className="text-sm">
          <div className="flex justify-between font-bold">
            <span>Total Bayar:</span>
            <span>Rp {prescriptionOrderData.order?.shipping_cost.toLocaleString('id-ID')}</span>
          </div>
          <p className="mt-1">
            <span className="font-bold">Status: </span>
            {prescriptionOrderData.transaction?.status_payment === 'payment' ? (
              <span className="text-green-600">Sudah Dibayar</span>
            ) : (
              <span className="font-bold">Menunggu Pembayaran</span>
            )}
            
          </p>
        </div>
      </div>
  </div>

  <div className="px-4 mt-4">
    <div className="bg-white border rounded-md shadow-sm p-4">
      {/* Header Icon & Title */}
      <div className="flex items-center mb-3">
        <div className="bg-teal-100 text-teal-600 p-2 rounded-full mr-2">
          <i className="fas fa-truck"></i>
        </div>
        <h2 className="font-semibold text-gray-800 text-sm">Status Pengiriman</h2>
      </div>

      {/* List Status */}
      <ul className="text-sm space-y-2 pl-2">
        {isLoading ? (
          <li className="text-gray-500 italic">Memuat status...</li>
        ) : prescriptionOrderTracking.length > 0 ? (
          prescriptionOrderTracking.map((data, key) => (
            <li key={key} className="flex flex-col items-start">
              <div className="flex items-start">
                <span
                  className={`h-3 w-3 rounded-full mr-2 mt-1 bg-teal-500`}
                ></span>
                <span className="text-gray-700">{data.status}</span>
              </div>
              <span className="text-xs text-gray-500 pl-5">{data.updated_time}</span>
            </li>
          ))
        ) : (
          <li className="text-gray-500">Belum ada status.</li>
        )}
      </ul>
    </div>

    {/* WhatsApp Button */}
    <div className="mt-4 flex justify-center">
      <a
        href="https://wa.me/6281390002249?text=Halo%20Admin%2C%20saya%20ingin%20bertanya%20tentang%20status%20pengiriman%20obat"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-teal-500 text-white px-4 py-2 rounded-full text-sm font-semibold flex items-center"
      >
        <i className="fab fa-whatsapp mr-2"></i> HUBUNGI VIA WHATSAPP
      </a>
    </div>
  </div>
  </>
  ) : ''
  }
  
  {/* Tombol Tebus Online & Tebus Sendiri */}
  {!showPdf && !prescriptionOrder && !isExpired && (
      <div className="mt-4">
        <div className="flex p-4">
          <div className="flex">
            <button
              type="submit"
              onClick={() => navigate(`/e-prescription/${prescriptionId}/order`)}
              className="p-2 mr-2 bg-teal-500 rounded text-white whitespace-nowrap flex items-center"
            >
              <i className="fas fa-shopping-cart mr-2"></i> Tebus Online
            </button>
            <button
              onClick={() => {
                setShowPdf(true);
                setShowButton(true);
              }}
              type="button"
              className="p-2 bg-teal-600 rounded text-white text-sm flex items-center"
            >
              <i className="fas fa-download mr-2"></i> Tebus Sendiri
            </button>
          </div>
        </div>
      </div>
    )}

    {isExpired && prescriptionData?.download !== 1 && (
      <div className="mt-4">
        <div className="flex p-4">
          <div className="flex">
            <button
              type="submit"
              onClick={() => navigate(`/home`)}
              className="p-2 mr-2 bg-teal-500 rounded text-white whitespace-nowrap flex items-center"
            >
              <i className="fas fa-sync-alt mr-2"></i> Konsultasi Ulang
            </button>
          </div>
        </div>
      </div>
    )}
     
    {showPdf && publicPdfUrl && !prescriptionOrder ? (
      <div className="mt-4 border rounded p-4 bg-white">
        <Document
          file={publicPdfUrl}
          onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          loading={<p>Loading PDF...</p>}
          error={<p>Gagal memuat PDF.</p>}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              width={window.innerWidth - 64} // agar responsif
            />
          ))}
        </Document>
        {!isExpired && showButton && prescriptionData?.download !== 1 ? (
            <div className="mt-4">
              <div className="flex flex-wrap gap-2 p-4">
                {/* Tombol Kirim Online */}
                <button
                  type="submit"
                  onClick={handleSendEmail}
                  className="p-2 bg-teal-500 rounded text-white whitespace-nowrap flex items-center"
                >
                  <i className="fas fa-paper-plane mr-2"></i> Kirim Email
                </button>

                {/* Tombol Download */}
                <button
                  onClick={handleDownloadPdf}
                  type="button"
                  className="p-2 bg-teal-600 rounded text-white text-sm flex items-center"
                >
                  <i className="fas fa-file-download mr-2"></i> Download
                </button>

                {/* Tombol Batal */}
                <button
                  onClick={() => setShowPdf(false)}
                  type="button"
                  className="p-2 bg-gray-500 rounded text-white text-sm flex items-center"
                >
                  <i className="fas fa-times-circle mr-2"></i> Batal
                </button>

                <SendEmail
                  isOpen={showModal}
                  onClose={() => setShowModal(false)}
                  onConfirm={handleConfirm}
                  email={email}
                />
              </div>
            </div>
          ) : null}

        
        
      </div>
    ) : null}



      {/* Bottom Navigation */}
      <BottomNav />
    </div>
  );
};

export default EprescriptionDetail;
